// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/ajax-location');
require('@js/accordions');
require('@js/swiper');
require('@js/select');
require('@js/scroll-to');
require('@js/cookies');
require('@js/header');
require('@js/menu');
require('@js/anchor');
require('@js/animations');
require('@js/aos');
require('@js/cursor');
require('@js/ajax-events');
require('@js/drag-to-scroll');